import React from "react";
export default function LEFT() {
  return <div>Excel_LEFT</div>;
}
